import React from 'react';
import PoolBox from './PoolBox';
import {
  credits,
  marketMetaLine,
  marketTitle,
  scheduleLabel,
  teamOdds,
  teamProbability,
} from './nxlUtils';

function TradePanel({
  selectedMarket,
  side,
  setSide,
  stake,
  setStake,
  marketPoolStats,
  marketStatsLoading,
  isAuthenticated,
  loginWithRedirect,
  quote,
  getQuote,
  tradeLoading,
  confirmStep,
  setConfirmStep,
  poolEstimate,
  placePosition,
}) {
  if (!selectedMarket) {
    return (
      <section className="nxl-odds-card nxl-sticky-ticket">
        <p className="nxl-kicker">TRADE TICKET</p>
        <h2>Select a market</h2>
        <p className="nxl-muted">Choose a scheduled matchup to build a trade ticket.</p>
      </section>
    );
  }

  return (
    <section className="nxl-odds-card nxl-sticky-ticket">
      <p className="nxl-kicker">TRADE TICKET</p>
      <h2>{marketTitle(selectedMarket)}</h2>

      <div className="nxl-selected-schedule">
        <strong>{scheduleLabel(selectedMarket)}</strong>
        <span>
          {selectedMarket.division}
          {marketMetaLine(selectedMarket) ? ` • ${marketMetaLine(selectedMarket)}` : ''}
        </span>
      </div>

      <div className="nxl-team-line">
        <button
          className={side === 'team_a' ? 'selected' : ''}
          onClick={() => {
            setSide('team_a');
            setConfirmStep(false);
          }}
        >
          <span>{selectedMarket.team_a}</span>
          <strong>{teamProbability(selectedMarket, 'team_a')}</strong>
          <em>{teamOdds(selectedMarket, 'team_a')}</em>
        </button>

        <button
          className={side === 'team_b' ? 'selected' : ''}
          onClick={() => {
            setSide('team_b');
            setConfirmStep(false);
          }}
        >
          <span>{selectedMarket.team_b}</span>
          <strong>{teamProbability(selectedMarket, 'team_b')}</strong>
          <em>{teamOdds(selectedMarket, 'team_b')}</em>
        </button>
      </div>

      <label className="nxl-field">
        <span>Stake</span>
        <input
          type="number"
          min="10"
          max="500"
          value={stake}
          onChange={(e) => {
            setStake(e.target.value);
            setConfirmStep(false);
          }}
        />
      </label>

      {marketStatsLoading ? (
        <p className="nxl-muted">Loading pool…</p>
      ) : (
        <PoolBox
          market={selectedMarket}
          poolStats={marketPoolStats}
          side={side}
          stake={stake}
        />
      )}

      {!isAuthenticated ? (
        <button className="nxl-primary-button nxl-full-button" onClick={loginWithRedirect}>
          Log in to trade
        </button>
      ) : !confirmStep ? (
        <>
          <div className="nxl-ticket-actions">
            <button
              className="nxl-secondary-button"
              onClick={getQuote}
              disabled={tradeLoading}
            >
              {tradeLoading ? 'Quoting…' : 'Get Quote'}
            </button>

            <button
              className="nxl-primary-button"
              onClick={() => setConfirmStep(true)}
              disabled={tradeLoading || !quote}
            >
              Review
            </button>
          </div>

          {!quote && (
            <p className="nxl-ticket-note">Get a fresh quote before reviewing this position.</p>
          )}
        </>
      ) : (
        <div className="nxl-confirm-inline">
          <p className="nxl-kicker">CONFIRM POSITION</p>
          <h3>{side === 'team_a' ? selectedMarket.team_a : selectedMarket.team_b}</h3>

          <div className="nxl-quote-box">
            <div><span>Your stake</span><strong>{credits(poolEstimate.stakeAmount)}</strong></div>
            <div><span>Projected pool</span><strong>{credits(poolEstimate.projectedTotalPool)}</strong></div>
            <div><span>House fee</span><strong>{credits(poolEstimate.projectedHouseFee)}</strong></div>
            <div><span>Net winner pool</span><strong>{credits(poolEstimate.projectedWinnerPool)}</strong></div>

            {poolEstimate.hasOpposingAction ? (
              <div className="nxl-quote-profit">
                <span>Estimated payout</span>
                <strong>{credits(poolEstimate.estimatedPayout)}</strong>
              </div>
            ) : (
              <div className="nxl-one-sided-warning">
                <strong>No opposing action yet.</strong>
                <span>
                  If every wager is on one side, there is no losing-side pool to fund payouts.
                  This may be refunded, voided, or manually reviewed.
                </span>
              </div>
            )}
          </div>

          <p className="nxl-ticket-note">
            Model odds are informational. Final payout depends on the final pool at lock/settlement.
          </p>

          <div className="nxl-ticket-actions">
            <button className="nxl-secondary-button" onClick={() => setConfirmStep(false)}>
              Back
            </button>

            <button
              className="nxl-primary-button"
              onClick={placePosition}
              disabled={tradeLoading}
            >
              {tradeLoading ? 'Placing…' : 'Confirm'}
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

export default TradePanel;